
import { useCallback } from 'react';
import { A2AMessage, MessageType } from '@/utils/a2a/types';
import { availableAgents, findAgentForCapability } from '@/utils/a2a/registry/agentRegistry';

export const useA2ACapabilityManagement = (setPendingMessages: (fn: (prev: A2AMessage[]) => A2AMessage[]) => void) => {
  const advertisingCapabilities = useCallback((agentId: string) => {
    const agent = availableAgents.find(a => a.id === agentId);
    if (!agent) return null;
    
    const message: A2AMessage = {
      id: `advert-${Date.now()}`,
      fromAgent: agent.id,
      toAgent: 'executive-agent',
      content: `Agent ${agent.name} is advertising capabilities: ${agent.capabilities.join(', ')}`,
      timestamp: new Date(),
      signature: '',
      keyId: '',
      metadata: {
        protocol: 'A2A',
        version: '1.1',
        messageType: 'CAPABILITY_ADVERTISEMENT' as MessageType,
        capabilities: agent.capabilities,
        interfaces: agent.interfaces || [],
        maxConcurrentTasks: agent.maxConcurrentTasks || 1,
        intent: 'capability-registration',
        priority: 'normal'
      }
    };
    
    setPendingMessages(prev => [...prev, message]);
    return message;
  }, [setPendingMessages]);

  const getAgentByCapability = useCallback((capability: string) => {
    return findAgentForCapability(capability);
  }, []);

  return {
    advertiseCapabilities: advertisingCapabilities,
    getAgentByCapability
  };
};
